import { format } from 'date-fns';
import { DATE_FORMAT } from '@app/constants/date';

export const ID_FOR_TABLE_OF_CONTENTS = 'table_of_contents';
export const CLASSNAME_FOR_PDF_READY = 'pdf-ready';
export const TODAY_STRING = format(new Date(), DATE_FORMAT);
